export interface CancelAppointmentWsV2Params {
  folderID: string;
  code: string;
  folderRef: string;
  comments?: string;
}

export interface CancelAppointmentWsV2ResponseSuccess {
  status: 'OK' | 'Accepted';
  response: {
    code: '200' | '202';
    message: 'Confirmed' | 'Accepted';
  };
  data: {
    folderID: string;
    slotId: string;
  };
}

export interface CancelAppointmentWsV2ResponseError {
  status: 'ERROR';
  response: {
    code: string;
    message: string;
  };
}
